import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import Base from './Base';
import AuthContext from '../context/AuthContext';
import Swal from 'sweetalert2';
import { Card, Button, Input, Alert, Spinner } from './ui';
import API_BASE_URL from '../config/api';
const ManageAddress = () => {
  const { user, authToken } = useContext(AuthContext);

  const [formData, setFormData] = useState({
    name: '',
    phone_number: '',
    address: '',
    state: '',
    city: '',
    country: '',
    pincode: ''
  });

  const fetchAddress = async () => {
    if (!authToken?.access) {
      console.warn("No auth token available for fetching address.");
      return;
    }
    try {
      const res = await axios.get(`${API_BASE_URL}/api/manage_address/`, {
        headers: {
          Authorization: `Bearer ${authToken.access}`,
        },
      });
      setFormData(prevData => ({ ...prevData, ...res.data }));
    } catch (err) {
      console.error("Failed to fetch address:", err);
    }
  };

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!authToken?.access) {

      Swal.fire({
        title: "Error",
        text: "Authentication token not found. Please log in again.",
        icon: "warning"
      });
      return;
    }
    try {
      await axios.post(`${API_BASE_URL}/api/manage_address/`, formData, {
        headers: {
          Authorization: `Bearer ${authToken.access}`,
        },
      });
      Swal.fire({
        title: "Good job!",
        text: "Address updated successfully!",
        icon: "success"
      });
    } catch (err) {
      console.error("Error saving address:", err.response?.data || err.message);
      Swal.fire({
        title: "Good job!",
        text: `Update failed. ${err.response?.data?.detail || 'Please try again.'}`,
        icon: "warning"
      });
    }
  };

  useEffect(() => {
    if (user && authToken) {
      fetchAddress();
    }

  }, [user, authToken]);

  const formFields = [
    { id: "name", label: "Full Name", type: "text" },
    { id: "phone_number", label: "Phone Number", type: "tel" },
    { id: "address", label: "Street Address / Building", isTextArea: true },
    { id: "city", label: "City" },
    { id: "state", label: "State / Province" },
    { id: "pincode", label: "Pincode / ZIP Code", type: "text" },
    { id: "country", label: "Country", type: "text" }
  ];

  return (
    <Base Content={
      <div className="font-lora flex flex-col min-h-screen bg-white">

        {/* Account Information Header - Stays at the top, does not scroll */}
        <div className="px-4 sm:px-6 py-4 sm:py-6 md:py-8 text-center md:text-left shrink-0 bg-white shadow-sm">
          <h3 className="font-semibold text-xl sm:text-2xl text-orange-600">Account</h3>
          {user?.username && (
            <p className="text-base sm:text-lg text-orange-400 mt-1 capitalize">{user.username}</p>
          )}
        </div>

        {/* Form Section - This part will grow and scroll if content overflows */}
        <div className="flex-grow overflow-y-auto px-4 sm:px-6 py-6 sm:py-8">
          <div className="w-full max-w-xl mx-auto p-6 sm:p-8 rounded-xl shadow-xl bg-white border border-orange-200">
            <h2 className="font-semibold text-center text-xl sm:text-2xl md:text-3xl mb-6 sm:mb-8 text-orange-600">
              Edit Address
            </h2>
            <form onSubmit={handleSubmit} className="space-y-5 md:space-y-6">
              {formFields.map(({ id, label, isTextArea, type = "text" }) => (
                <div key={id}>
                  <label
                    htmlFor={id}
                    className="block text-sm sm:text-base font-medium mb-1.5 text-orange-600"
                  >
                    {label}
                  </label>
                  {isTextArea ? (
                    <textarea
                      id={id}
                      name={id}
                      className="w-full p-2.5 border border-orange-300 rounded-md text-sm sm:text-base focus:outline-none focus:ring-2 focus:ring-orange-400 focus:border-orange-500 transition-colors duration-150 ease-in-out"
                      rows="3"
                      required
                      value={formData[id] || ''}
                      onChange={handleChange}
                    />
                  ) : (
                    <input
                      type={type}
                      id={id}
                      name={id}
                      value={formData[id] || ''}
                      className="w-full p-2.5 border border-orange-300 rounded-md text-sm sm:text-base focus:outline-none focus:ring-2 focus:ring-orange-400 focus:border-orange-500 transition-colors duration-150 ease-in-out"
                      required
                      onChange={handleChange}
                    />
                  )}
                </div>
              ))}
              <div className="pt-3 sm:pt-4 flex justify-center">
                <button
                  type="submit"
                  className="w-full sm:w-auto sm:min-w-[180px] py-2.5 sm:py-3 px-6 bg-gradient-to-r from-orange-500 to-orange-600 text-white border-none rounded-lg cursor-pointer text-base sm:text-lg font-medium hover:from-orange-600 hover:to-orange-700 transition-all duration-300 shadow-md hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-orange-400 focus:ring-offset-2"
                >
                  Save Changes
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    } />
  );
};

export default ManageAddress;